<template>
<v-container fluid style="max-width: 1280px;">
    <v-row no-gutters align="center">
        <v-col cols="10">
            <im-title-bar :title="hotel.name?hotel.name:'Hotel page'" />
        </v-col>
        <v-col cols="2" class="d-flex justify-end">
            <v-btn depressed color="primary" to="/">
                <v-icon size="20">arrow_back_ios</v-icon>
                <span class="">Back</span>
            </v-btn>
        </v-col>
    </v-row>

    <v-row no-gutters v-if="availability&&availability.rooms.length > 0">
        <v-col cols="12" md="8">
            <v-card color="green" class="pa-1">
                <im-room-best-offer :hotel="hotel" :availability="availability" />
            </v-card>
            <im-room-list :hotel="hotel" :availability="availability" />
            <!-- <im-hotel-info :hotel="hotel" /> -->
        </v-col>
        <v-col cols="12" md="4">
            <im-desktop-summary :availability="availability" @book="goToReservation()" />
        </v-col>
    </v-row>
</v-container>
</template>

<script>
import IMTitleBar from '@/components/items/TitleBar.vue';
import IMRoomList from '@/components/items/RoomList.vue';
import IMRoomBestOffer from '@/components/items/RoomBestOffer.vue';
import IMHotelInfo from '@/components/items/HotelInfo.vue';
import IMDesktopSummary from '@/components/items/SummaryDesktop.vue';

import {
    getHotelAvailabilityById,
    getHotelById
} from "@/api/Booking";

export default {

    components: {
        'im-title-bar': IMTitleBar,
        'im-hotel-info': IMHotelInfo,
        'im-room-list': IMRoomList,
        'im-room-best-offer': IMRoomBestOffer,
        'im-desktop-summary': IMDesktopSummary,
    },

    data() {
        return {

            hotel: {},
            availability: null,

            searching: false,

            query: {
                place_id: null,
                check_in: this.$moment()
                    .format('YYYY-MM-DD'),
                check_out: this.$moment()
                    .add(1, 'days')
                    .format('YYYY-MM-DD'),
                rooms: [{
                    adults: [{
                        age: 'a'
                    }],
                    children: []
                }],
                currency: 'RON'
            }

        }
    },

    created() {
        this.getOffersHotelId();
    },

    methods: {

        async load() {
            let {
                hotelId
            } = this.$route.params;

            let {
                data: hotel
            } = await getHotelById(hotelId);
            let availability = await getHotelAvailabilityById(hotelId, this.query);

            this.hotel = hotel;
            this.availability = availability;
        },

        getOffersHotelId() {

            let query = this.$route.query;
            if(!Array.isArray(query.occupancy)) {
                query.occupancy = [query.occupancy];
            }
            // setup query endpoint
            let secure = process.env.VUE_APP_HTTP_SECURE === 'true' ? 'https://' : 'http://';
            let endpoint = secure + process.env.VUE_APP_ENDPOINT_SERVICES_PROXY + '/api/services-new/athena/v1/search/hotels/' + this.$route.params.hotelId;

            // setup query params
            let params = {
                params: query
            };

            this.$axios.get(endpoint, params)
                .then(response => {
                    this.hotel = response.data.data.hotel
                    this.availability = response.data.data;
                    this.availability.check_in = this.$route.query.check_in;
                    this.availability.check_out = this.$route.query.check_out;;
                })
                .catch(error => {
                    console.log(error);
                })
                .finally(() => {});
        },

        goToReservation() {
            this.$router.push('/reservation')
        }

    }

}
</script>
